import type { FaireProductEntity } from "../../entity_types/product";

export const atc_baggu_6: FaireProductEntity = {
  token: "atc_baggu_6",
  type: "product",
  name: "Ribbed Ankle Sock - Black",
  brandName: "Baggu",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/900b834f05edc02048f254fa1d0d3f8b89cf4b5015c5c8761d5b8b78080b18f7.jpeg",
  priceDollars: 7,
  msrpDollars: 14,
  description: "Reusable bag made from recycled materials by Baggu.",
  tags: ["bags", "accessories", "sustainable"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "atc-entity-migration",
  },
};
